import type { SearchPagination, SearchResponse } from '@algolia/client-search';

import type { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

import type { CmsApiPage } from './types/CmsApiPage';
import type { CmsApiRedirect } from './types/CmsApiRedirect';
import type { CmsApiSearchLandingPage } from './types/CmsApiSearchLandingPage';
import type { CmsApiPageSlug } from './types/CmsApiTypedId';

type ApiResponse = {
  type: string;
  data: CmsApiPage | CmsApiRedirect | CmsApiSearchLandingPage;

  /**
   * `ssrLandingPageResults` is only available during SSR
   */
  ssrLandingPageResults?: SearchResponse<SearchAlgoliaHit> &
    Required<SearchPagination>;
};

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (slug: CmsApiPageSlug) => `/data/website/contents/${slug}`,
  mapResponse,
});

// Exports

export const cmsApiFetchPage = endpoint.createClientFetchFn();

export const cmsApiIsomorphicFetchPage = endpoint.createIsomorphicFetchFn();
